export const LeaderboardTableHeader = () => {
  return (
    <thead>
      <tr className="text-blue-gray">
        <th className="pb-4 text-left font-medium">Rank</th>
        <th className="pb-4 text-left font-medium">Player</th>
        <th className="pb-4 text-left font-medium">Points</th>
        <th className="pb-4 text-left font-medium">Picks</th>
        <th className="pb-4 text-left font-medium">Pick %</th>
        <th className="pb-4" />
      </tr>
    </thead>
  );
};
